'use strict';

export const NAV_ORGANIZATION_LIST_NAME = 'navOrganizations';
export const NAV_ORGANIZATION_LIST_PREFIX = `@@${NAV_ORGANIZATION_LIST_NAME}`;

export const NAV_PROJECT_LIST_NAME = 'navProjects';
export const NAV_PROJECT_LIST_PREFIX = `@@${NAV_PROJECT_LIST_NAME}`;

export const NAV_ASSET_PROJECT_LIST_NAME = 'navAssetProjects';
export const NAV_ASSET_PROJECT_LIST_PREFIX = `@@${NAV_ASSET_PROJECT_LIST_NAME}`;

export const NAV_ASSET_LIST_NAME = 'navAsset';
export const NAV_ASSET_LIST_PREFIX = `@@${NAV_ASSET_LIST_NAME}`;



// WEBPACK FOOTER //
// ./src/js/app/navigation/redux/state.js